import {
  Component,
  input,
  output,
  HostListener,
  ViewEncapsulation
} from '@angular/core';
import { CommonModule } from '@angular/common';

export type ModalHeaderIconType = 'cyan' | 'blue' | 'emerald' | 'amber' | 'rose' | 'none';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
  encapsulation: ViewEncapsulation.Emulated
})
export class ModalComponent {
  readonly isOpen = input<boolean>(false);
  readonly title = input<string>('');
  readonly description = input<string>('');
  readonly maxWidth = input<string>('560px');
  readonly iconType = input<ModalHeaderIconType>('none');
  readonly closeOnOverlay = input<boolean>(false);
  readonly closeOnEsc = input<boolean>(true);
  readonly showCloseButton = input<boolean>(true);

  readonly close = output<void>();

  @HostListener('window:keydown.escape', ['$event'])
  handleKeyDownEscape(event?: Event) {
    if (this.isOpen() && this.closeOnEsc()) {
      event?.preventDefault();
      this.close.emit();
    }
  }

  onOverlayClick(event: MouseEvent) {
    if (this.closeOnOverlay()) {
      this.close.emit();
    }
  }
}
